import { getFunciton, postWithoutTokenFunciton } from 'utils/ApiHelper'

import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
// Server should return AuthModel
export async function login(email: string, password: string) {
  const res = await postWithoutTokenFunciton("login", {
    username: email,
    password: password,
  })
  return res
}

// Server should return AuthModel
export async function register(data: object) {
  const res = await postWithoutTokenFunciton("register", data)
  return res
}

export async function changePassword(data: object) {
  const res = await postWithoutTokenFunciton("user/change-password", data)
  return res
}

export async function randomPasswordBySuperAdmin(data: object) {
  const res = await postWithoutTokenFunciton("admin/random-password", data)
  return res
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.get<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    params: {
      email: email,
    },
  })
}

export async function getUserByToken() {
  const res:any = await getFunciton("userinfo")
  return res;
}
